import { type SubscriptionsConfig } from "@voxmedia/duet-context/context/config-context";

import { MEMBERSHIP_CONFIG } from "./membership.config";

const config: SubscriptionsConfig = {
  entitlement: MEMBERSHIP_CONFIG.entitlementName ?? "",
  /**
   * Paths that should not be used as a post-checkout redirect destination.
   * Users landing on this widget from one of these pages will be sent to the
   * homepage after a successful checkout instead.
   */
  forbiddenRedirectPaths: [
    "/subscribe",
    "/subscribe-winback",
    "/subscribe-now",
    "/checkout",
    "/subscribe-flash-sale",
  ],
  subscriptionPlanSelectionAnalytics: {
    name: "verge",
    position: "subscribe_page",
  },
};

export default config;
